import styled from '@emotion/styled'
import { Container, Grid, useTheme } from '@mui/material'
import React from 'react'
import { Heading, P, SectionHeading, SectionSmallHeading, SectionSubHeading, SectionWrapper } from '../../../Styles/style'
import video from "../../../../assets/images/0001.mp4"
import tokenimg from "../../../../assets/images/tokenomics.png"
import telegram from "../../../../assets/images/telegram.png"
import twitter from "../../../../assets/images/twitter.png"
import uni from "../../../../assets/images/uni.png"
import dex from "../../../../assets/images/dex.png"
import eth from "../../../../assets/images/eth.png"
import Twitter from "../../../../assets/images/Twitter-1.png"
import Telegram from "../../../../assets/images/tele1.png"
const DIv = styled.div`
display:flex;
justify-content:space-between;
align-items:CENTER;
padding:10px 0;
`
const Div2 = styled.div`
text-align-last: center;

`
const Tokenimg = styled.img`
width:100%;
height:auto;
max-width:500px;
`
const Socimg = styled.img`
width:100%;
height:auto;
@media screen and(max-width:400px){

} 
`
const Value = styled.p`
color: #fff;
position: absolute;
    /* top: 29px; */
    left: 70px;
    @media screen and (max-width:1199px){
        bottom: 29px;
        left: 70px;
        font-size: 12px;
    }
`
const Grids = styled(Grid)`
    /* display: flex; */
`

const BuyNow = styled.a`
text-decoration: none;
background-color: ${(props) => (props.bgColor ? props.bgColor : '#000')};
color: ${(props) => (props.Color ? props.Color : props.theme.textPrimary)};
padding: 12px 20px;
border-radius: 5px;
margin-right: 15px;
display: flex;
align-items: center;
width:100%;
max-width:200px;
border:1px solid #00FF00;
    float: right;


`
const Ca = styled.div`
text-align: center;  background:linear-gradient(235deg, #00EAFF 20%,#0080FF 30%,#0080FF 27%,#8000FF 43%, #E619E6 60%,#FF0000 92%);
border-radius:10px;
padding:10px 0;
margin:10px 0;
 `
const MAinaWrap = styled.div`
text-align: center;  
background-color:#001524;
border-radius:10px;
padding:10px 30px;
margin:10px 0;
 `
const Wrap = styled.div`
display:flex;
justify-content:center;
gap:10px;
padding:50px 0 30px;
 `
const GridWrap = styled(Grid)`
 display:flex;
 align-items:center;
 `

 const VideoBK = styled.video`
  object-fit: cover;
  width: 100%;
  max-width: 100%;
  height: auto;
`;
const S6_Tokenomics = () => {
    const theme = useTheme()
    return (
        <div>
            <SectionWrapper p="4rem 0" id="tokenomics" >
                <Container maxWidth="xl">
                    <SectionHeading fs599="40PX" fs399="40PX" fs="80px" align="CENTER" p="10px 0" m="0" data-aos="flip-up"
                        data-aos-easing="ease-in"
                        data-aos-delay="500"
                        data-aos-duration="500"
                        data-aos-offset="0">Start Your $Shib Journey</SectionHeading>

                    <GridWrap container>
                        <Grid item xs={12} md={2} data-aos="fade-up"
                            data-aos-anchor-placement="center-bottom" data-aos-delay="500"
                            data-aos-duration="500">
                             {/* <VideoBK autoPlay loop muted>
                                <source src={video} type="video/mp4" />
                                </VideoBK> */}
                        </Grid>
                        <Grid item xs={12} md={8} data-aos="fade-up"
                            data-aos-anchor-placement="center-bottom" data-aos-delay="500"
                            data-aos-duration="500" >

                            <P align="center"
                                            p="0 0 40px 0"
                                            m="0"
                                            data-aos="fade-zoom-in"
                                            data-aos-easing="ease-in"
                                            data-aos-delay="700"
                                            data-aos-duration="600"
                                            data-aos-offset="0"
                                        >
                                        oin our lively Shib community! Connect with us on
social media platforms, participate in engaging
discussions on interactive forums, and be part of our
live events. Together, we'll celebrate milestones and
shape the future of Shib.
                                        </P>
                                        <Div2>
                        <a href="https://t.me/pulseshibportal" target="blank">
                            <img src={Telegram} />
                        </a>
                        &nbsp;
                        &nbsp;
                        &nbsp;
                        <a href="https://twitter.com/pulseshib_token" target="blank">
                            <img src={Twitter} />
                        </a>
                    </Div2>
                                         {/* <BuyNow >CHART</BuyNow> */}
                            {/* <MAinaWrap>
                                <DIv>
                                    <Heading >Token Symbol</Heading>
                                    <Heading align="left" p="0" m="0" >$POTC </Heading>
                                </DIv>
                                <DIv>
                                    <Heading >Total Supply</Heading>
                                    <Heading align="left" p="0" m="0" >TBA</Heading>
                                </DIv>
                                <DIv>
                                    <Heading >Taxes</Heading>
                                    <Heading align="left" p="0" m="0" >TBA</Heading>
                                </DIv>
                                <DIv>
                                    <Heading >Prc20 Contract</Heading>
                                    <Heading align="left" p="0" m="0" >TBA</Heading>
                                </DIv>
                                <Ca><SectionSubHeading fs="20px" align="center" p="0" m="0" >Buy on PulseX</SectionSubHeading></Ca>
                            <Wrap>
                                <a href="" target="blank">
                                <Socimg src={telegram}/>
                                </a>
                                <a href="" target="blank">
                                <Socimg src={twitter}/>
                                </a>
                                <a href="" target="blank">
                                <Socimg src={eth}/>
                                </a>
                                <a href="" target="blank">
                                <Socimg src={uni}/>
                                </a>
                                <a href="" target="blank">
                                <Socimg src={dex}/>
                                </a>
                            </Wrap> */}
                            {/* </MAinaWrap> */}
                        </Grid>
                        <Grid item xs={12} md={2} data-aos="fade-up"
                            data-aos-anchor-placement="center-bottom" data-aos-delay="500"
                            data-aos-duration="500">
                             {/* <VideoBK autoPlay loop muted>
                                <source src={video} type="video/mp4" />
                                </VideoBK> */}
                        </Grid>

                    </GridWrap>

                </Container>
            </SectionWrapper>
        </div>
    )
}

export default S6_Tokenomics